<template>
   <div class="chart-container">
      <canvas ref="canvas"></canvas>
   </div>
</template>

<script>
import { Chart, LineController, LineElement, PointElement, LinearScale, Title, CategoryScale, Legend, Tooltip } from 'chart.js';
Chart.register(LineController, LineElement, PointElement, LinearScale, Title, CategoryScale, Legend, Tooltip);

export default {
   name: "LineaChart",
   props: {
      grafica: {
         type: Object,
         required: true
      }
   },

   data() {
      return {
         chartInstance: null
      };
   },

   mounted() {
      this.renderChart();
   },

   watch: {
      grafica: {
         deep: true,
         handler() {
            this.renderChart();
         }
      }
   },

   methods: {
      renderChart() {
         const ctx = this.$refs.canvas.getContext("2d");
         // Destruir gráfico anterior si existe
         if (this.chartInstance) {
            this.chartInstance.destroy()
            this.chartInstance = null
         }
         // Crear nueva instancia
         this.chartInstance = new Chart(ctx, {
            type: "line",
            data: {
               labels: this.grafica.datos.map((punto) => punto.plazo),
               datasets: [
                  {
                     label: this.grafica.titulo,
                     data: this.grafica.datos.map((punto) => punto.valor),
                     borderColor: "red",
                     borderWidth: 2,
                     backgroundColor: "rgba(0, 0, 255, 0.1)",
                     tension: 0.4,
                  },
               ],
            },
            options: {
               responsive: true,
               plugins: {
                  legend: { display: false },
                  title: {
                     display: true,
                     text: this.grafica.titulo,
                     color: '#00aeef',
                     font: {
                        size: 16,
                        weight: 'bold',
                        family: 'Montserrat',
                     },
                  },
               },
               scales: {
                  x: { type: "category" },
                  y: { type: "linear" },
               },
            },
         });
      }
   }
};
</script>

<style scoped>
.chart-container {
   padding: 10px;
   border-radius: 10px;
}

canvas {
   max-width: 100%;
}
</style>